/**
 * Constantes para os perfis de usuário do sistema ASAS
 *
 * Estrutura de níveis de acesso:
 * - ADMIN_INSTITUCIONAL (1): Administrador da instituição
 * - DESIGNER_INSTRUCIONAL (2): Designer instrucional
 * - USUARIO_COMUM (8): Usuário comum (acesso via LTI)
 *
 * is_admin:
 * - 1: Administrador geral do sistema (desenvolvedores/gerente)
 * - 0 ou null: Usuário normal
 */

export const USER_ROLES = {
  ADMIN_INSTITUCIONAL: 1,
  DESIGNER_INSTRUCIONAL: 2,
  USUARIO_COMUM: 8,
};

export const ROLE_NAMES = {
  [USER_ROLES.ADMIN_INSTITUCIONAL]: "Administrador Institucional",
  [USER_ROLES.DESIGNER_INSTRUCIONAL]: "Designer Instrucional",
  [USER_ROLES.USUARIO_COMUM]: "Usuário Comum",
};

export const ROLE_PERMISSIONS = {
  // Administrador Institucional - acesso completo da instituição
  [USER_ROLES.ADMIN_INSTITUCIONAL]: [
    "view_dashboard",
    "manage_users",
    "manage_courses",
    "manage_content",
    "manage_library",
    "access_library",
    "view_reports",
    "manage_institution",
    // "access_shop",
    "access_profile",
    "access_home",
    "view_mycart",
    "view_customizeprofile",
    "view_checkout",
    "access_videos",
    "access_simulated",
  ],

  // Designer Instrucional - criação e gestão de conteúdo
  [USER_ROLES.DESIGNER_INSTRUCIONAL]: [
    "view_dashboard",
    "manage_content",
    "manage_courses",
    "manage_library",
    "access_library",
    "view_reports",
    // "access_shop",
    "view_manage",
    "access_profile",
    "access_home",
    "access_videos",
    "access_simulated",
  ],

  // Usuário Comum - acesso básico ao conteúdo
  [USER_ROLES.USUARIO_COMUM]: [
    "view_content",
    "access_library",
    "access_courses",
    "access_simulated",
    "access_videos",
    // "access_shop",
    "access_profile",
    "access_home",
  ],
};

// Permissões exclusivas de administradores gerais do sistema (is_admin = 1)
export const SYSTEM_ADMIN_PERMISSIONS = [
  "view_system_panel",
  "manage_all_institutions",
  "view_system_analytics",
  "manage_system_settings",
  "access_developer_tools",
];

// Rotas que requerem login tradicional (Login.vue)
export const TRADITIONAL_LOGIN_ROLES = [
  USER_ROLES.ADMIN_INSTITUCIONAL,
  USER_ROLES.DESIGNER_INSTRUCIONAL,
];

// Rotas que permitem login via LTI (AuthToken.vue)
export const LTI_LOGIN_ROLES = [USER_ROLES.USUARIO_COMUM];

/**
 * Verifica se um perfil pode fazer login tradicional
 */
export function canUseTraditionalLogin(codigoPerfil) {
  return TRADITIONAL_LOGIN_ROLES.includes(codigoPerfil);
}

/**
 * Verifica se um perfil pode fazer login via LTI
 */
export function canUseLtiLogin(codigoPerfil) {
  return LTI_LOGIN_ROLES.includes(codigoPerfil);
}

/**
 * Verifica se é um administrador geral do sistema
 */
export function isSystemAdmin(isAdmin) {
  return isAdmin === 1 || isAdmin === true;
}
